import { z } from "zod";
import { ExternalIdSchema, ListIdSchema, ProviderIdSchema, TaskIdSchema } from "./branded.js";
// Explicit unions rather than `z.infer` of the enum schema — see the note in
// subscription.ts (cross-package consumers mis-resolve deferred zod-enum infers).
export const TaskPrioritySchema = z.enum(["low", "medium", "high"]);
export const TaskStatusSchema = z.enum(["pending", "in_progress", "completed"]);
const _taskPriorityParity = true;
const _taskStatusParity = true;
void _taskPriorityParity;
void _taskStatusParity;
export const TaskSchema = z.object({
    id: TaskIdSchema,
    title: z.string(),
    description: z.string().optional(),
    status: TaskStatusSchema,
    priority: TaskPrioritySchema.optional(),
    dueDate: z.date().optional(),
    completedAt: z.date().optional(),
    listId: ListIdSchema,
    provider: ProviderIdSchema,
    externalId: ExternalIdSchema,
    createdAt: z.date(),
    updatedAt: z.date(),
    metadata: z.record(z.string(), z.unknown()).optional(),
});
export const TaskListSchema = z.object({
    id: ListIdSchema,
    name: z.string(),
    provider: ProviderIdSchema,
    externalId: ExternalIdSchema,
    isDefault: z.boolean().default(false),
    createdAt: z.date(),
    updatedAt: z.date(),
    metadata: z.record(z.string(), z.unknown()).optional(),
});
export const CreateTaskRequestSchema = z.object({
    title: z.string(),
    description: z.string().optional(),
    status: TaskStatusSchema.optional().default("pending"),
    priority: TaskPrioritySchema.optional(),
    dueDate: z.date().optional(),
    listId: ListIdSchema,
});
export const UpdateTaskRequestSchema = CreateTaskRequestSchema.partial();
//# sourceMappingURL=task.js.map